module.exports = __webpack_public_path__ + "static/media/styledc.924041ba.png";